import type { AnyRealtimeRun } from "@trigger.dev/core/v3"

export interface OperationProgressPhase {
	kind: string
	[extra: string]: unknown
}

export interface OperationProgress {
	done: number
	total: number
	phase: OperationProgressPhase
}

export interface OperationRun {
	id: string
	status: string
	output: unknown
	progress?: OperationProgress
	payload: unknown
}

export function toOperationRun(run: AnyRealtimeRun): OperationRun {
	const metadata = run.metadata as Record<string, unknown> | undefined
	const progress = metadata?.progress as OperationProgress | undefined

	return {
		id: run.id,
		status: run.status,
		output: run.output,
		payload: run.payload,
		progress: progress && isValidPhase(progress.phase) ? progress : undefined,
	}
}

function isValidPhase(value: unknown): value is OperationProgressPhase {
	return (
		typeof value === "object" &&
		value !== null &&
		typeof (value as { kind?: unknown }).kind === "string"
	)
}
